const state = () => ({
  searchFilter: null,
  searchText: null,
  searchSidebarText: null,
  searchMultiple: null,
  searchFiltersQuery: null,
  searchResult: null,
  searchQuery: null,
  searchLinks: null,
  searchSource: null,
  totalCount: null,
  results: null,
  allResultsTab: null,
  pageCount: null,
  watchlist: null,
  // Semantic search state
  semanticResults: [],
  semanticQuery: "",
  semanticLoading: false,
  semanticTotalAccessible: 0,
  semanticTotalUpsell: 0,
  refinements: [],
  refinementsLoading: false,
  queryLogId: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  appendData(state, data) {
    state[data.label].push(data.data);
  },
  setSearchQuery(state, data) {
    const queryPrev = state[data.label];
    const queryNew = data.query;
    if (queryNew === undefined) {
      state[data.label] = queryPrev;
    } else {
      state[data.label] = { ...queryPrev, ...queryNew };
    }
    if (!data.changePage) state[data.label].offset = "0";
  },
  setSemanticResults(state, payload) {
    state.semanticResults = payload.results || [];
    state.semanticTotalAccessible = payload.total_accessible || 0;
    state.semanticTotalUpsell = payload.total_upsell || 0;
    state.semanticQuery = payload.query || "";
    state.queryLogId = payload.query_log_id || null;
  },
  setRefinements(state, suggestions) {
    state.refinements = suggestions || [];
  },
  clearSemanticResults(state) {
    state.semanticResults = [];
    state.semanticTotalAccessible = 0;
    state.semanticTotalUpsell = 0;
    state.refinements = [];
    state.queryLogId = null;
  },
};

const actions = {
  async getData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.jsonApiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch((err) => {
        console.error(err.response, url);
      });
  },
  async getViewData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {});
  },
  // Legacy ES search (kept for backward compatibility)
  async getSearchData({ commit, state }, params) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}/es/search/`,
      params,
    };
    return await this.$axios(body)
      .then(({ data }) => {
        commit("setData", { label: "totalCount", data: data.count });
        commit("setData", { label: "results", data: data.results });
        const arr = Object.entries(data.results).map((el) => el[1]);
        const arrResult = arr.map((el) => el.results);
        let allResult = [];
        arrResult.forEach((el) => {
          allResult = allResult.concat(el);
        });
        commit("setData", { label: "allResultsTab", data: allResult });
        arr.sort(function (a, b) {
          if (a.count > b.count) return -1;
          if (a.count < b.count) return 1;
          return 0;
        });
        commit("setData", { label: "pageCount", data: arr[0].count });
        commit("setData", { label: "searchSource", data: params.source || null });
      })
      .catch((err) => {
        console.error(err.response, body.url);
      });
  },

  /**
   * Semantic search via Skywalker.
   */
  async semanticSearch({ commit }, { query, topK }) {
    commit("setData", { label: "semanticLoading", data: true });
    const baseURL = this.$config ? this.$config.baseURL : "http://pc.loc:8005";
    try {
      const { data } = await this.$axios({
        method: "POST",
        url: `${baseURL}/api/viq/search`,
        data: { query, top_k: topK || 75 },
        headers: { "Content-Type": "application/json" },
      });
      commit("setSemanticResults", data);
    } catch (err) {
      console.error("Semantic search error:", err.response || err);
      commit("clearSemanticResults");
    } finally {
      commit("setData", { label: "semanticLoading", data: false });
    }
  },

  /**
   * Fetch query refinement suggestions (fire-and-forget style).
   */
  async fetchRefinements({ commit }, { query }) {
    commit("setData", { label: "refinementsLoading", data: true });
    commit("setRefinements", []);
    const baseURL = this.$config ? this.$config.baseURL : "http://pc.loc:8005";
    try {
      const { data } = await this.$axios({
        method: "POST",
        url: `${baseURL}/api/viq/search/refine`,
        data: { query },
        headers: { "Content-Type": "application/json" },
      });
      commit("setRefinements", data.suggestions || []);
    } catch (err) {
      console.error("Refinement error:", err.response || err);
    } finally {
      commit("setData", { label: "refinementsLoading", data: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
